import React, { useState } from 'react';

import PropTypes from 'prop-types';

export default function ActionLink({
  dataMethod = null,
  disableAfterClick = false,
  linkText,
  openUnsavedChangesModal,
  performCheck = null,
  rel = null,
  style,
  styleClasses,
  target = null,
  url,
}) {
  const [disabled, setDisabled] = useState(false);

  const disableMultipleClicks = (event) => {
    if (disabled) {
      event.preventDefault();
    } else if (!disabled) {
      setDisabled(true);
    }
  };

  const handleClick = (event) => {
    if (performCheck) {
      event.preventDefault();
      openUnsavedChangesModal?.(linkText);
    } else if (disableAfterClick) {
      disableMultipleClicks(event);
    }
  };

  return (
    <a
      className={styleClasses}
      data-disabled={disabled}
      data-method={performCheck || disabled || !dataMethod ? null : dataMethod}
      href={url}
      onClick={handleClick}
      rel={disabled || !rel ? null : rel}
      style={style}
      target={target}
    >
      {linkText}
    </a>
  );
}

ActionLink.propTypes = {
  dataMethod: PropTypes.string,
  disableAfterClick: PropTypes.bool,
  linkText: PropTypes.string,
  openUnsavedChangesModal: PropTypes.func,
  performCheck: PropTypes.bool,
  rel: PropTypes.string,
  style: PropTypes.object,
  styleClasses: PropTypes.string,
  target: PropTypes.string,
  url: PropTypes.string.isRequired,
};
